<template>
  <div class="index">
    <div class="nav_left">
      <div class="resreach">
        <!-- <el-input
          v-model="reachinput"
          placeholder="可搜索平台题库系统或题库系列"
        ></el-input>
        <el-button type="text" class="sreacbtn">搜索</el-button> -->
        <el-tag type=""> 请在左边先添加子级和试卷名称后再收藏题 </el-tag>
      </div>
      <div class="treecontent">
        <el-tree
          :data="treedata"
          node-key="id"
          :default-expanded-keys="defaultExpanded"
          :load="loadNode"
          lazy
          :props="defaultProps"
          ref="treeref"
        >
          <span
            class="custom-tree-node"
            @mouseenter="mouseenter(node.id)"
            @mouseleave="mouseleave(node.id)"
            slot-scope="{ node }"
          >
            <span
              @click="openChild(node)"
              :style="{ 'margin-right': '20px' }"
              >{{ node.label }}</span
            >
            <span
              v-if="node.level == '1'"
              class="erjibtn"
              :class="{ is_show: node.id == isShowTreebtn }"
            >
              <el-button
                type="text"
                size="mini"
                @click.stop="() => createMulu(node)"
              >
                新增子级
              </el-button>
            </span>
            <span
              v-if="node.level == '2'"
              class="erjibtn"
              :class="{ is_show: node.id == isShowTreebtn }"
            >
              <el-button
                type="text"
                size="mini"
                @click.stop="() => createErji(node)"
              >
                新增试卷
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click.stop="() => deleteMulu(node)"
              >
                删除
              </el-button>
            </span>
            <span
              v-if="node.level == '3'"
              class="erjibtn"
              :class="{ is_show: node.id == isShowTreebtn }"
              ><el-button
                type="text"
                size="mini"
                @click.stop="() => deleteMulu(node, '3')"
              >
                删除
              </el-button></span
            >
          </span>
        </el-tree>
      </div>
    </div>
    <div class="nav_right">
      <div class="nav_right_top">
        <div>
          <el-button type="primary" @click="openQusetion">添加收藏</el-button>
          <el-button type="danger" @click="deleteTestArr">批量删除</el-button>
        </div>
        <div class="resreach resreachinput">
          <el-input
            v-model="tablereachinput"
            placeholder="可搜索平台题库系统或题库系列"
          ></el-input>
          <el-button type="text" class="sreacbtn">搜索</el-button>
        </div>
      </div>
      <div class="depart_table">
        <el-table
          ref="table"
          @selection-change="tableCheckBoxFun"
          :data="getData"
          row-key="TestID"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column
            type="selection"
            width="60"
            align="center"
            :reserve-selection="true"
          ></el-table-column>

          <el-table-column label="序号" type="index" width="60" align="center"
            ><template slot-scope="scope">
              <span>{{ pageCurrent * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column label="题目名称" align="center">
            <template slot-scope="scope">
              <p class="titleStyle">
                {{ scope.row.TestJSON.Title || scope.row.TestJSON.MainTitle }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="添加人" align="center" width="100px">
            <template slot-scope="scope">
              {{ scope.row.realName }}
            </template>
          </el-table-column>
          <el-table-column label="添加时间" align="center" width="200px">
            <template slot-scope="scope">
              {{ scope.row.CreateTime }}
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="250">
            <template slot-scope="scope">
              <div class="operation_box">
                <!-- <el-button
                  type="text"
                  size="small"
                  @click.stop="details(scope.row, '3')"
                  >查看</el-button
                > -->
                <el-button
                  type="text"
                  @click="deleteListItem(scope.row)"
                  size="small"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="StartPageCurrent"
            :page-size="pageSize"
            :page-sizes="pagesizesArr"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            class="pagination"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CollectCustomClassList,
  ChapterThree,
  ChapterTestListInfo,
  AddCollect,
  ChapterManager,
  Delete,
  DeleteImportSingleTest,
  DeleteTestBatch,
} from "@/api/quebankmana.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      reachinput: "", //tree搜索
      tablereachinput: "", //table搜索的结果。
      treedata: [
        //树组件的数据。
        {
          id: 0,
          name: "全部",
          disabled: "true",
          children: [
            // {
            //   name:'医学考试(全体库)',
            //   id:'1',
            //   children:[]
            // },
            {
              name: "医学三基考试系统",
              id: "2",
              disabled: "true",
              children: [],
            },
            {
              name: "中医考试系统",
              id: "3",
              disabled: "true",
              children: [],
            },
            {
              name: "护理考试系统",
              id: "4",
              disabled: "true",
              children: [],
            },
            {
              name: "临床医学考试系统",
              id: "5",
              disabled: "true",
              children: [],
            },
            {
              name: "住院医师考试系统",
              id: "6",
              disabled: "true",
              children: [],
            },
            {
              name: "卫生系统招聘考试系统",
              id: "7",
              disabled: "true",
              children: [],
            },
            {
              name: "医学法律法规考试系统",
              id: "8",
              disabled: "true",
              children: [],
            },
            {
              name: "其他培训考试系统",
              id: "9",
              disabled: "true",
              children: [],
            },
            {
              name: "其他题库（未分配）",
              id: "10",
              disabled: "true",
              children: [],
            },
          ],
        },
      ],
      defaultExpanded: [], //自动展开的数据id
      isShowTreebtn: -1,
      dialogState: {
        first: "当前平台系统题库：",
        scend: "题库系列名称：",
      }, //弹窗状态
      editDialog: false,
      indexDialogVisible: false, //dialog确认框的唤起
      getData: [], //分页数据列表
      defaultProps: {
        children: "children",
        label: "AppClassName",
        isLeaf: "leaf",
      },
      getApppageList: {
        classId: "",
        className: "",
      },
      treeOneData: "", //一级树ID
      pageSelectData: [], //选中的数据模型。
      //   ExamCptID: "", //章节ID  不要了
      AppClassID: "", //树结构第一级的ID
      AppID: "", // 树结构二层的
      StartPageCurrent: 0, //初始化时页码使用
      pageCurrent: 0, //当前页码
      pageSize: 10, //每页的页数
      pagesizesArr: [5, 10, 20],
      total: 0,
    };
  },
  props: ["custom"],
  methods: {
    getRowKey(row) {
      return row.id;
    },
    async getPageList() {
      //分页初始化。
      let parms = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        url: "/api/customTest/ChapterManager/CustomClassList",
        hid: JSON.parse(loginvuex.state.hid),
        pageIndex: 0,
        PageShow: 100,
        Directory: "",
        keyStr: ".bottom",
      };
      let res = await CollectCustomClassList(parms);
      console.log(res);
      let newarr = [
        {
          ID: "10001",
          AppClassName: "全部",
          children: res.data.Data.Data,
        },
      ];

      this.treedata = newarr;
      // this.getData = res.data.data.records;
      // this.total = res.data.data.total;
    },
    loadNode(node, resolve) {
      if (node.level == 0) {
        let newarr = [
          {
            id: "10001",
            AppClassName: "全部",
          },
        ];
        this.defaultExpanded = ["10001"];
        let parms = {
          guid: JSON.parse(loginvuex.state.userlist).guid,
          UserID: JSON.parse(loginvuex.state.userlist).userID,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          url: "/api/customTest/ChapterManager/CustomClassList",
          hid: JSON.parse(loginvuex.state.hid),
          pageIndex: 0,
          PageShow: 100,
          Directory: "",
          keyStr: ".bottom",
        };
        CollectCustomClassList(parms).then((res) => {
          //  this.treedata =  res.data.Data.Data;
          // this.treeOneData = res.data.Data.Data;
          this.treedata = newarr;
          newarr[0]["children"] = res.data.Data.Data;
          //return   resolve(res.data.Data.Data);
          resolve(newarr);
        });
      }
      if (node.level == 1) {
        console.log(node);
        resolve(node.data.children);
      }
      if (node.level == 2) {
        let res = {
          ClassID: node.data.AppClassID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          hid: JSON.parse(loginvuex.state.hid),
        };
        ChapterThree(res).then((resa) => {
          let newchildr = resa.data.Data.Three.map((item) => {
            let newobj = {};
            newobj["ID"] = item.ID;
            newobj["AppClassName"] = item.Name;
            newobj["leaf"] = true;
            newobj["children"] = item.Childs.map((items) => {
              let newchild = {};
              newchild["ID"] = items.Childs[0].Childs[0].ID;
              newchild["AppClassName"] = items.Name;
              newchild["leaf"] = true;
              return newchild;
            });
            return newobj;
          });
          //这里需要拿到子集的数据，返回过来。
          return resolve(newchildr);
        });
      }
      if (node.level == 3) {
        //  return resolve(node.data.children);
        return resolve([]);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAppList();
    },
    handleCurrentChange(val) {
      this.pageCurrent = val - 1;
      this.getAppList();
    },
    tableCheckBoxFun(val) {
      console.log(val);
      this.pageSelectData = val; //选中的数据全部存储。
    },
    // 树按钮鼠标移入事件
    mouseenter(nodeId) {
      // console.log("mouseenter", nodeId);
      this.isShowTreebtn = nodeId;
    },
    // 树按钮鼠标移出事件
    mouseleave(nodeId) {
      // console.log("mouseleave", nodeId);
      this.isShowTreebtn = -1;
    },
    cancel() {
      this.indexDialogVisible = false;
      this.dialogForm.isChangeQues = "";
    },
    deleteListItem(data) {
      //删除
      console.log(data);
      //  this.getAppList();

      this.$confirm("确认删除？", "提示")
        .then((_) => {
          let parmas = {
            TestID: JSON.stringify([data.TestID]),
            examID: data.ExamCptID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
            hid: JSON.parse(loginvuex.state.hid),
            userID: JSON.parse(loginvuex.state.userlist).userID,
          };
          DeleteImportSingleTest(parmas).then(() => {
            this.$message.success("删除成功");
            this.getAppList();
          });
        })
        .catch((_) => {});
    },
    deleteTestArr() {
      //批量删除.
      if (this.pageSelectData.length == 0) {
        this.$message.error("没有选择题目");
        return;
      }
      let newarr = this.pageSelectData.map((item) => {
        return item.TestID;
      });
      console.log(newarr);
      let parmas = {
        TestIDArr: JSON.stringify(newarr),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.hid),
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      DeleteTestBatch(parmas).then(() => {
        this.getAppList();
      });
      this.$message.success("删除成功");
      this.$refs.table.clearSelection();
    },
    details(row) {
      //查看详情
      console.log(row);
    },
    openChild(row) {
      //   console.log(row);
      if (row.level == 1) {
        this.AppClassID = "";
        this.AppID = "";
        this.pageCurrent = 0;
        this.StartPageCurrent = 0;
        this.getAppList();
      }
      if (row.level == 2) {
        console.log(row);
        this.AppClassID = row.data.AppClassID;
        this.AppID = "";
        this.pageCurrent = 0;
        this.StartPageCurrent = 0;
        this.getAppList();
      }
      if (row.level == 3) {
        console.log(row);
        this.AppClassID = row.parent.data.AppClassID;
        this.AppID = row.data.ID;
        this.pageCurrent = 0;
        this.StartPageCurrent = 0;
        this.getAppList();
      }
      // if (row.level == 3) {
      //   console.log(row);
      //   this.ExamCptID = row.data.ID;
      //   this.pageCurrent = 0;
      //   this.StartPageCurrent = 0;
      //   this.getAppList();
      // }
      //传入当前参数
    },
    openQusetion(row) {
      //打开题库
      console.log(this.treedata);
      this.$parent.dialogForm.classNameOptions = this.treedata[0].children;
      console.log(this.$parent.dialogForm.classNameOptions);
      this.custom(1);
    },
    createMulu() {
      //创建目录
      let res = {
        AppID: -1,
        ParentID: -1,
        ChapterName: "",
        Level: 0,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      this.$prompt("请输入分组名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: this.checkfunc,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          console.log(value);
          res.ChapterName = value;
          AddCollect(res);
          setTimeout(() => {
            this.getPageList();
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消添加",
          });
        });
    },
    deleteMulu(row, num) {
      //删除
      console.log(row, num);
      let parmas = {
        CptID: row.data.AppClassID,
        Level: 0,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      this.$confirm(`确定删除${row.data.AppClassName}吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (num == "3") {
            parmas.CptID = row.data.ID;
            parmas.Level = "1";
          }
          Delete(parmas);
          console.log(parmas);
          setTimeout(() => {
            this.getPageList();
          }, 1000);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    createErji(row) {
      //新增子级
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        Level: 1, //等级
        ChapterName: "", //分组名称
        AppID: -1,
        ParentID: row.data.AppClassID,
      };
      this.$prompt("请输入分组名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: this.checkfunc,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          res.ChapterName = value;
          ChapterManager(res);
          setTimeout(() => {
            this.getPageList();
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消添加",
          });
        });
    },
    //校验输入框的字段
    checkfunc(inputs) {
      if (inputs === "") {
        return false;
      }
      return true;
    },
    getAppList() {
      //获取题目的分页列表
      let parms = {
        PageIndex: this.pageCurrent,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        HospitalID: JSON.parse(loginvuex.state.hid),
        PageShow: this.pageSize,
        //ExamCptID: this.ExamCptID,
        AppClassID: this.AppClassID,
        AppID: this.AppID,
      };
      ChapterTestListInfo(parms).then((resa) => {
        resa.data.Data.data.forEach((item) => {
          item.TestJSON = JSON.parse(item.TestJSON);
        });
        this.getData = resa.data.Data.data;
        this.total = resa.data.Data.count;
        console.log(resa);
      });
    },
  },
  created() {
    this.getAppList();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-cascader-node__label{
   white-space: normal;
}
::v-deep .el-cascader-node{
  height: 100%;
  padding:  10px;
}
.index {
  //  width: 20%;
  display: flex;
  min-height: 800px;
  background-color: #f8f8f8;
}
.nav_left {
  width: 25%;
  border-radius: 10px;
  height: 800px;
  overflow: auto;
  background-color: rgb(255, 255, 255);
}
.resreach {
  display: flex;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  .sreacbtn {
    margin-left: 20px;
  }
}
.treecontent {
  padding-top: 30px;
  padding-left: 40px;
}
.treecontent {
  ::v-deep.el-tree-node__content {
    margin-bottom: 10px;
    .el-checkbox .is-disabled {
      display: none;
    }
  }
}
.treeNodeLength {
  display: inline-block;
  width: 120px;
  height: 100%;
  line-height: 12px;
  // height: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.nav_right {
  border-radius: 10px;
  margin-left: 1%;
  width: 74%;
  min-height: 800px;
  background-color: rgb(255, 255, 255);
  padding-top: 10px;
}
.nav_right_content {
  width: 100%;
  margin-left: 0px;
}
.nav_right_top {
  display: flex;
  justify-content: space-between;
  .el-button {
    height: 40px;
    margin-left: 50px;
  }
  .resreachinput {
    // margin-left: 600px;
    padding-top: 0px;
    width: 400px;
  }
}
.depart_table {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

.operation_box {
  width: 250px;
  text-align: center;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 25px;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
    }
  }
}
.dialog_index {
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
}
.is_show {
  visibility: visible !important;
}
.erjibtn {
  visibility: hidden;
}
.titleStyle {
  width: 500px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>